export default {
  meau: {
    nav1: '首页',
    nav2: '社区',
    nav3: '下载客户端',
    nav4: '节点奖励',
    nav5: 'NFT'
  },
  cont1: {
    text1: '基于区块链技术的远程控制软件',
    text2: '多屏互联，工作娱乐随时随地',
    btn: '立即免费下载',
    text3_1: '加入',
    text3_2: '社区',
    text3_3: '获得DeepLink Coin奖励'
  },
  cont2: {
    text1: 'DeepLink',
    text2: '依托电竞级的低延迟技术能力，让所有设备触手可及',
    text3: '核心能力与技术优势',
    text4: '基于云游戏核心能力，体验远超传统远控！',
    leaf1: {
      text1: '高流畅、高性能',
      text2: '低成本',
      text3: '业界一流的编解码方案，同码率性能消耗与资源占用最小。',
      text4: 'peer-to-peer:  支持ipv6，高达 95% NAT打通率，零带宽占用。'
    },
    leaf2: {
      text1: '高帧率、低延迟',
      text2: '',
      text3: '局域网延迟＜15ms，并具备4K 240Hz的能力，广域网评测也处于全球第一阵营。'
    },
    leaf3: {
      text1: '高清晰',
      text2: '',
      text3: '智能算法提升同等码率下的可视效果，还原最逼真的色彩表现。'
    },
    leaf4: {
      text1: '高稳定',
      text2: '',
      text3: '大量数据支撑下的抗丢包、抗拥塞策略，可快速地对数据包丢失和拥塞进行调整。'
    },
    leaf5: {
      text1: '高安全',
      text2: '',
      text3: '所有数据通过AES256的DTLS1.2加密 。'
    }
  },
  cont3: {
    text1: '丝滑流畅，就像操控本地设备',
    text2: '应用三大领域，数十项的优化技术，DeepLink可实现在发生5%丢包率、100ms网络延迟*的情况下，依旧保持高帧率流畅运行。满足各类网络环境的使用要求。',
    li1: {
      text1: '弱网对抗技术',
      text2: 'FEC抗丢包策略',
      text3: '带宽预测',
      text4: 'SVC编码策略'
    },
    li2: {
      text1: '传输优化技术',
      text2: '端口指纹预测',
      text3: 'IPV6支持',
      text4: 'UPNP',
      text5: '智能选路'
    },
    li3: {
      text1: '显示处理技术',
      text2: '帧率自适应策略',
      text3: '动态画面预测',
      text4: 'Jitter处理策略',
      text5: 'AI低码高清渲染',
      text6: '动态虚拟现实器'
    },
    desc3: '局域网 < 5 ms  ·  城际网络 < 10 ms  ·  跨省网络 < 30 ms'
  },
  cont4: {
    text1: '超清晰的图形画质',
    text2: '极清分辨率',
    text3: '10.7亿色彩支持',
    text4: '4:4:4 无损画质',
    text5: 'DeepLink始终采用更苛刻的 画质指标，以实现远超其他传统远程技术的 图像体验，远程图像失真度低于人眼可识别极限值，全力支撑创意行业对画面显示效果的精准要求。',
    text6: '*PSNR指峰值信噪比，低于20dB时画面失真度度高，20—30dB时画面失真度一般，30—40dB时画面失真度低，大于40dB时画面失真度极低且肉眼不可察觉。'
  },
  cont5: {
    text1: '丰富的外设支持',
    text2: 'DeepLink为创意行业提供了 数位板、手柄 等专业外设的远程支持，并针对PS、Zbrush、Unity等创意软件的进行使用优化，确保了远程状态与本地状态下的创意生产工具 体验一致性。'
  },
  cont6: {
    text1: '多重保障 · 极简操作',
    block1: {
      title1: '账号安全',
      desc1: '多层账号保护机制，放心用',
      title2: '连接安全',
      desc2: 'DTLS1.2协议保护，有授权才能访问',
      title3: '数据安全',
      desc3: '256位AES加密 传输全过程保密',
      title4: '设备安全',
      desc4: '按您的设置，只让对应的人看到对应的设备'
    },
    block2: {
      title1: '多重安全保障',
      desc1: '为每次连接保驾护航',
      title2: '操作简单',
      desc2: '轻松启动',
    },
    block3: {
      title1: '下载轻量',
      desc1: 'DeepLink客户端仅约10M',
      title2: '上手简单',
      desc2: '根据指引即可完成配置流程',
      title3: '使用轻松',
      desc3: '通过鼠标就可远控权限内的任意设备'
    }
  },
  cont7: {
    text1: '致力于提供远控解决方案',
    block1: {
      word1: '教育行业',
      word2: '游戏行业',
      word3: '创意设计行业',
      word4: '信息技术行业',
      word5: '出差的业务人员',
      word6: '分散在各地的协作者',
      word7: 'IT运维远程维护 ',
      word8: '个人用户和游戏玩家'
    },
    block2: {
      text1: '支持各行业的远控场景',
      text2: '基于各行业的企业实际需求，助力企业节能高效地实现业务目标。',
      text3: '提供个性化定制和加密策略、灵活安全',
      text4: '公司员工能够随时随地根据实际权限访问公司资源。'
    },
    block3: {
      text1: '覆盖多种用户需求',
      text2: '不管您是选择给企业内部员工使用，',
      text3: '还是外部客户、合作者、甚至个人使用。',
      text4: '我们的远控能力能在主流平台、设备上为您服务，',
      text5: '提供另一种简单、聪明的问题解决途径。'
    }
  },
  footer: {
    link: '友情链接',
    community: '关注社区',
    tip: '说明：社区包含 Twitter、telegram、reddit、medium、discord、tiktok、YouTube'
  },
  reward: {
    title1: 'DeepLink 节点',
    desc1: '拥有获得奖励的机会，例如：DeepLink Token、皇冠NFT、社区治理的权力。',
    title2: '获取创世节点NFT',
    text1: 'DeepLink的网络用户越多，需要越多的计算和流量，创世节点为DeepLink网络提供基础设施，从而实现去中心化和帮助DeepLink更快速的发展。',
    text2: '通过购买创世节点NFT，您就可以因为对网络的贡献而获得奖励的机会。',
    text3: '这可能包括DeepLink Token、皇冠NFT、社区治理的权力。',
    text4_1: '有什么疑问吗？ 来',
    text4_2: '和',
    text4_3: '上面与我们一起交流。',
    btntext: '立刻购买',
    text5: '每售卖1000个创世节点NFT，价格增加1000USD',
    text6_1: '当前每NFT',
    text6_2: '支持节点数',
    text7: '创世节点NFT总数',
    text8: '永不增发',
    text9: '初始价格',
    text10_1: '每NFT支持',
    text10_2: '节点最大数',
    text11: '最高价格',
    text12: '什么是创世节点？',
    text13: '创世节点承担DeepLink网络计算和流量转发的核心任务，DeepLink通过挖矿的模式，让更多人可以参与获得收益。',
    text14: '总共有多少Token给到创世节点奖励？',
    text15: '币总数的30%，300亿枚DeepLink Token',
    text16: '创世节点NFT是什么',
    text17: '只有拥有创世节点NFT才能参与挖矿。',
    text18: '创世节点NFT售卖的收入怎么分配？',
    text19: '收益的50%投入到去中心化流动性奖励池（例如：Uniswap、Sushiswap的 DeepLink Token/USDC），50%为DeepLink运营公司收益。',
    text20: '具体的挖矿机制是什么？',
    text21: '一年总共奖励50亿，3年减半，DeepLink 皇冠NFT收益的10%回购DeepLink Token，每次减半前添加入总的奖励池，作为总的奖励50%Token，分3年奖励给所有节点。比如3年后，DeepLink 皇冠NFT收益的10%回购DeepLink Token为 120亿枚，则奖励池剩余总数变为：120亿+150亿，总共为270亿枚，第二个3年开始每年总奖励为270亿*50%*1/3=45亿。',
    text22: '创世节点机器有什么要求？',
    text23: '每个机器必须已经在DeepBrain Chain的网络中，DeepBrain Chain是一个去中心化的高性能算力网络，在深脑链中的机器已经质押了DBC，可以保证机器的稳定性。关于深脑链的详细了解：',
    text24: '持有创世节点NFT还有哪些其他好处？',
    details: {
      text1: '1.持有一定数量的创世节点NFT可获得一个国家的DeepLink NFT售卖总代理权(根据国家人口比例每300万人需要一个1个NFT)；',
      text2: '2.DeepLink Coin空投；',
      text3: '3.DeepLink孵化游戏项目代币空投；',
      text4: '4.投票上线游戏权限；',
      text5: '5.游戏NFT购买折扣；',
      text6: '6.云游戏版权和时长购买折扣；',
      text7: '7.其他参与社区治理权限。'
    }
  },
  nft: {
    cont: {
      title1: '皇冠NFT',
      desc1: '拥有这个NFT，DeepLink软件的所有功能都可以有1年的使用权限。',
      desc2: 'NFT被购买后处于休眠状态，当需要使用此NFT时，可以在DeepLink软件中激活，当NFT被激活后',
      desc3: '开始进行倒计时，1年使用期限。DeepLink软件NFT收益的10%投入到节点奖励，',
      desc4: '收益的40%投入到流动性奖励池，50%为DeepLink运营公司收益。',

      
      desc1_1: '拥有这个NFT，DeepLink软件的所有功能都可以有1年的使用权限。',
      desc2_1: 'NFT被购买后处于休眠状态，当需要使用此NFT时，可以在DeepLink软件中激活，当NFT被激活后,开始进行倒计时，1年使用期限。',
      desc3_1: 'DeepLink软件NFT收益的10%投入到节点奖励，收益的40%投入到流动性奖励池，50%为DeepLink运营公司收益。',
    },
    enabl: {
      title1: 'NFT赋能',
      desc1: 'DeepLink软件的所有功能有1年的使用权限',
      desc2: 'DeepLink Coin空投',
      desc3: 'DeepLink孵化游戏项目代币空投',
      desc4: '投票上线游戏权限',
      desc5: '游戏NFT购买折扣',
      desc6: '云游戏版权和时长购买折扣',
      desc7: '其他参与社区治理权限'
      
    },
    edition: {
      title1: '专业版',
      title2: '企业版',
      tip: '皇冠NFT',
      btn: '立即购买',
      title3: '专业版 VS 企业版',
      desc: '具体功能使用权限',
      list: {
        li1_1: '内容',
        li1_2: '基础版',
        li1_3: '专业版',
        li1_4: '企业版',
        li2_1: '最优画质',
        li3_1: '转发机房',
        li3_2: '少量',
        li3_3: '大量',
        li4_1: '转发带宽',
        li4_2: '最大4M',
        li4_3: '最大20M',
        li4_4: '不限',
        li5_1: '端到端延时',
        li5_2: '最低<40ms',
        li5_3: '最低<20ms',
        li6_1:'通道数',
        li7_1:'设备数',
        li8_1:'远程桌面',
        li9_1:'远程摄像头',
        li10_1:'远程 SSH',
        li11_1:'隐私屏',
        li12_1:'虚拟显示器',
        li13_1:'游戏键鼠',
        li14_1:'多路串流',
        li15_1:'444真彩',
        li16_1:'录屏截屏',
        li17_1:'双屏对双屏',
        li18_1:'手柄、数位板',
        li19_1:'用户/设备分组管理',
        li20_1:'SSO单点登录',
        li21_1:'统一管理授权',
        li22_1:'批量部署',
        li23_1:'员工行为审计',
        li24_1:'水印',
        li25_1:'价格'
      }
    }
  }
}